<template>
    <div class="vx-row">
        <div class="vx-col md:w-1/2 w-full">
          <vs-input class="w-full" label="E-shop" v-model="eshop.eshopId" name="username" />
        </div>
        <div class="vx-col md:w-1/2 w-full">
          <vs-input class="w-full" label="Url" v-model="eshop.eshopURL" name="username" />
        </div>
    </div>
</template>
<script>
export default {
  name: 'asdasd',
  props: {
    value: {
      type: Object,
      required: true
    }
  },
  computed: {
    eshop: {
      get () { return this.value },
      set (eshop) { this.$emit('input', eshop) }
    }
  }
}
</script>
